import angular from "angular";
import { QpuiBreadcrumbItemDirective } from "./qpui-breadcrumb-item.directive";
import { QpuiBreadcrumbDirective } from "./qpui-breadcrumb.directive";

let module_name = "qpui.bootstrap.breadcrumb";

let breadcrumbModule = angular.module(module_name, []);

breadcrumbModule.directive({
    qpuiBreadcrumb: QpuiBreadcrumbDirective,
    qpuiBreadcrumbItem: QpuiBreadcrumbItemDirective
})


export { breadcrumbModule, module_name }